/**
 * Main Entry Point
 * React application bootstrap
 */

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './index.css';

// Initialize i18n
import './lib/i18n.js';

// Loading fallback for i18n
function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
        <p className="mt-4 text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </StrictMode>
);
